import type { DesignNode, SvgNodeData } from '../types/node.types';
import { v4 as uuidv4 } from 'uuid';

export const createImageNode = (
  src: string,
  surface: string,
  productType: string,
  position: { x: number; y: number },
  size: { width: number; height: number },
  zIndex?: number
): DesignNode => ({
  id: uuidv4(),
  type: 'image',
  productType,
  surface,
  position,
  size,
  rotation: 0,
  opacity: 1,
  visible: true,
  zIndex: zIndex ?? 0,
  data: {
    src,
    alt: ''
  }
});


export const createShapeNode = (
  shapeType: 'rectangle' | 'circle' | 'triangle',
  surface: string,
  productType: string,
  position: { x: number; y: number },
  size: { width: number; height: number }
): DesignNode => ({
  id: uuidv4(),
  type: 'shape',
  productType,
  surface,
  position,
  size,
  rotation: 0,
  opacity: 1,
  visible: true,
  zIndex: 0,
  data: {
    shapeType,
    fill: '#ff0000',
    stroke: '#000000',
    strokeWidth: 2
  }
});

export const createTextNode = (
  surface: string,
  productType: string,
  position: { x: number; y: number }
): DesignNode => ({
  id: uuidv4(),
  type: 'text',
  productType,
  surface,
  position,
  size: { width: 200, height: 50 },
  rotation: 0,
  opacity: 1,
  visible: true,
  zIndex: 0,
  data: {
    text: 'Your text here',
    fontSize: 24,
    fontFamily: 'Inter',
    fontWeight: 400,
    fontStyle: 'normal',
    fill: '#000000',
    textAlign: 'left',
  },
});

export const createSvgNode = (
  src: string,
  surface: string,
  productType: string,
  position: { x: number; y: number },
  size: { width: number; height: number },
  originalColors: string[],
  zIndex?: number
): DesignNode => ({
  id: uuidv4(),
  type: 'svg',
  productType,
  surface,
  position,
  size,
  rotation: 0,
  opacity: 1,
  visible: true,
  zIndex: zIndex ?? 0,
  data: {
    src,
    alt: '',
    fill: originalColors[0] || '#000000',
    originalColors,
  } satisfies SvgNodeData,
});

export const cloneNode = (node: DesignNode): DesignNode => ({
  ...node,
  id: uuidv4(),
  position: {
    x: node.position.x + 20,
    y: node.position.y + 20
  }
});
